<ion-app>
  <ion-tabs> </ion-tabs>
</ion-app>
